import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class OutputUnit extends Component {
	render() {
		const { unit } = this.props;
		return <span className="output-unit">{unit}</span>;
	}
}
OutputUnit.propTypes = {
	unit: PropTypes.string
};
export default OutputUnit;
